import type { CalendarFeed } from '@escala/contracts';

import type { Api } from '@/services/api/escala';

/**
 * Link da agenda pessoal (assinatura .ics): o servidor guarda um link secreto por membro,
 * que o Google Agenda, o celular ou o Outlook buscam sozinhos.
 */
export interface CalendarClient {
  feed: () => Promise<CalendarFeed>;
  /** Gera outro link; o anterior para de funcionar. */
  rotate: () => Promise<CalendarFeed>;
}

export function apiCalendar(api: Api): CalendarClient {
  return { feed: api.calendarFeed, rotate: api.rotateCalendarFeed };
}
